import React from "react";
import { ADMIN_LOGIN } from "./__queries__";
import LoginPage from "./LoginPage";

const AdminLoginPage = () => (
  <LoginPage
    loginMutation={ADMIN_LOGIN}
    fallbackPath="/admin"
    event="Admin logged in"
    initialTitle="Admin log in"
    currentAccount={null}
    accounts={[]}
  />
);

export default AdminLoginPage;
